<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/couponmanage/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            addShowPower="/couponmanage/add"
        >
            <el-form-item label="名称">
                <el-input
                    type="text"
                    v-model="formModel.couponName"
                    placeholder="请输入名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.payTypeCode"
                        :label="item.payTypeName"
                        :value="item.payTypeCode"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="可用产品">
                <el-select v-model="formModel.hardwareType">
                    <el-option
                        v-for="item in hardwareTypeStatus"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="couponName"
                label="名称"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="couponAmt"
                label="面值(元)"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="tranAmt"
                label="交易额度(元)"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="hardwareType"
                label="交易类型"
                min-width="350"
                :formatter="formatterTableKycp"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value="1"
                        :inactive-value="0"
                        @change="statusturns($event, scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                v-if="hasPerm('/couponmanage/caozuo')"
                label="操作"
                min-width="100"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="openAddDialog(scope.row)"
                    >修改
                    </el-button>
                    <el-button type="text" @click="handleDelete(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="439px"
        >
            <el-form-item label-width="150px" label="名称" prop="couponName">
                <el-input
                    type="text"
                    maxlength="100"
                    v-model="dialogModel.couponName"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label-width="150px" label="面值(元)" prop="couponAmt">
                <el-input-number
                    style="width: 217.34px"
                    v-model="dialogModel.couponAmt"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="150px" label="交易额度(元)" prop="tranAmt">
                <el-input-number
                    style="width: 217.34px"
                    v-model="dialogModel.tranAmt"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item
                label-width="150px"
                label="交易类型(可多选)"
                prop="hardwareType"
            >
                <el-select multiple v-model="dialogModel.hardwareType">
                    <el-option
                        v-for="item in hardwareTypeStatus.slice(
              1,
              hardwareTypeStatus.length
            )"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";
    import PosService from "service/PosService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "couponmanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                show: false,
                formModel: {
                    name: "",
                },
                tableData: [],
                submitService: TransactionService.couponmanageList,
                itemId: "",
                dialogModel: {
                    couponName: "",
                    couponAmt: undefined,
                    tranAmt: undefined,
                    hardwareType: [],
                },
                dialogRules: {
                    couponName: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    couponAmt: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    tranAmt: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    hardwareType: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                },
                status: [
                    {
                        payTypeCode: "",
                        payTypeName: "全部",
                    },
                    {
                        payTypeCode: 0,
                        payTypeName: "停用",
                    },
                    {
                        payTypeCode: 1,
                        payTypeName: "启用",
                    },
                ],
                hardwareTypeStatus: [{dictKey: "", dictValue: "全部"}],
                isFlag: false,
                currentTypes: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
            this.getTypeNames("transType", (res) => {
                this.hardwareTypeStatus = [...this.hardwareTypeStatus, ...res];
            });
        },
        computed: {
            submitData() {
                this.params = {
                    couponName: this.formModel.couponName,
                    status: this.formModel.status,
                    hardwareType: this.formModel.hardwareType,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogData() {
                const params = {
                    couponName: this.dialogModel.couponName,
                    couponAmt: this.dialogModel.couponAmt,
                    tranAmt: this.dialogModel.tranAmt,
                    hardwareType: this.dialogModel.hardwareType.join(","),
                };
                if (this.itemId) {
                    params.id = this.itemId;
                }
                return params;
            },
            dialogService() {
                return this.itemId
                    ? TransactionService.couponmanageEdit
                    : TransactionService.couponmanageInsert;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.formModel = {
                    status: "",
                    hardwareType: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            // handleDelete(item) {
            //   this.showConfirm("是否删除？")
            //     .then(() => {
            //       this.doDelete(item.id);
            //     })
            //     .catch(() => {});
            // },
            // doDelete(id) {
            //   this.doLoad(
            //     TransactionService.couponmanageDel,
            //     {
            //       id: id,
            //     },
            //     (res) => {
            //       this.doCheck(res, (res) => {
            //         this.commonSuccess(res);
            //       });
            //     },
            //     "操作失败"
            //   );
            // },
            statusturns($event, scope) {
                this.doStatus($event, scope);
            },
            doStatus($event, scope) {
                this.doLoad(
                    TransactionService.couponmanageStatus,
                    {
                        id: scope.id,
                        status: $event,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            openAddDialog(item, flag) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.isFlag = true;
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    const Arr = this.dialogModel.hardwareType.split(",");
                    this.dialogModel.hardwareType = Arr.map((item) => item);
                }
                this.$refs.formDialog.open();
            },
            handleDelete(item) {
                this.showConfirm("是否删除？")
                    .then(() => {
                        this.doDelete(item.id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    TransactionService.couponmanageDel,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            dialogClose() {
                this.dialogModel = {
                    couponName: "",
                    couponAmt: undefined,
                    tranAmt: undefined,
                    hardwareType: [],
                };
                this.itemId = "";
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatterTableKycp(row, column, cellValue, index) {
                let values = [];
                const cellRows = cellValue.split(",");
                for (let i = 0; i < cellRows.length; i++) {
                    const currentValue = cellRows[i].trim();
                    const item = this.hardwareTypeStatus.find(
                        (status) => status.dictKey == currentValue
                    );
                    if (item) {
                        values.push(item.dictValue);
                    } else {
                        values.push("--");
                    }
                }
                const value = values.join(", ");
                return value;
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/CouponManage.vue